<div [class]="containerClass">
    <mat-form-field [class]="fieldClass" hideRequiredMarker>
        <mat-label appRemoveAriaOwns> {{ firstDayOfPeriodLabel | translate }} </mat-label>
        <mat-select
            required
            name="dayOfMonth"
            [ngModel]="getIntervals()"
            (ngModelChange)="setIntervals($event)"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            (selectionChange)="previewDataChanged()"
        >
            <mat-option *ngFor="let interval of monthlyIntervals" [value]="interval">{{
                'time-off-v3.semiMonthlyDateOption'
                    | translate
                        : {
                              firstDay: interval.firstDay | ordinalNumber,
                              secondDay:
                                  interval.secondDay > 0
                                      ? (interval.secondDay | ordinalNumber)
                                      : ('time-off-v3.lastDay' | translate),
                          }
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
